// extracted by mini-css-extract-plugin
export default {"wrapper":"GWc3AM","container":"ttPGqH","content":"IB9Db3"};